import { defineMessages } from 'react-intl';

export const messages: {
	modalDialogLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	modalDialogLabel: {
		id: 'navigation.global-invite.modal-dialog-label',
		description: 'Accessible label of the modal dialog for assistive technologies users.',
		defaultMessage: 'Invite people',
	},
});
